import { PriceAfterChangeValues } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  values: PriceAfterChangeValues;
  onValuesChange: (field: keyof PriceAfterChangeValues, value: number) => void;
  translations: ToolsTranslations['priceAfterChange'];
}

export default function CalculatorInputs({ values, onValuesChange, translations }: Props) {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium text-gray-900 mb-4">{translations.inputs.title}</h3>
        <div className="space-y-4">
          <div>
            <label htmlFor="initial" className="block text-sm font-medium text-gray-700 mb-2">
              {translations.inputs.initial}
            </label>
            <div className="relative">
              <input
                id="initial"
                type="number"
                value={values.initial}
                onChange={(e) => onValuesChange('initial', parseFloat(e.target.value) || 0)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="0"
                min="0"
                step="0.01"
              />
              <span className="absolute right-3 top-2 text-sm text-gray-500">kr</span>
            </div>
          </div>

          <div>
            <label htmlFor="percent" className="block text-sm font-medium text-gray-700 mb-2">
              {translations.inputs.percent}
            </label>
            <div className="relative">
              <input
                id="percent"
                type="number"
                value={values.percent}
                onChange={(e) => onValuesChange('percent', parseFloat(e.target.value) || 0)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="0"
                step="0.01"
              />
              <span className="absolute right-3 top-2 text-sm text-gray-500">%</span>
            </div>
            <p className="mt-2 text-sm text-gray-500">{translations.inputs.hint}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
